import type { DashboardSchedule } from "../../services/schedules.service";

export function formatScheduleTime(value: string | null): string {
  if (!value) return "Never";

  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  }).format(new Date(value));
}

export function getScheduleBadge(schedule: DashboardSchedule): {
  label: string;
  className: string;
} {
  if (schedule.running) {
    return {
      label: "Running",
      className: "border-blue-600/30 bg-blue-600/10 text-blue-900",
    };
  }

  if (schedule.enabled) {
    return {
      label: "Enabled",
      className: "border-lime-600/30 bg-lime-600/10 text-lime-900",
    };
  }

  return {
    label: "Disabled",
    className: "border-muted-foreground/30 bg-muted text-muted-foreground",
  };
}

export function getLastRunText(schedule: DashboardSchedule): {
  text: string | null;
  isError: boolean;
} {
  return {
    text: schedule.lastError ?? schedule.lastMessage,
    isError: Boolean(schedule.lastError),
  };
}
